export default "__VITE_ASSET__cb6b7413__"